import { render } from "./BaseGenericOffcanvas.vue?vue&type=template&id=1f8e9f2a&scoped=true"
import script from "./BaseGenericOffcanvas.vue?vue&type=script&lang=js"
export * from "./BaseGenericOffcanvas.vue?vue&type=script&lang=js"

import "./BaseGenericOffcanvas.vue?vue&type=style&index=0&id=1f8e9f2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8e9f2a"]])

export default __exports__